export default {
  // ===========================================================================
  // Common labels
  // ===========================================================================
  common: {
    actions: "Actions",
    add: "Add",
    alerts: "Alerts",
    all: "All",
    assign: "Assign",
    cancel: "Cancel",
    chooseFiles: "Choose file | Choose files",
    close: "Close",
    confirm: "Are you sure you want to perform this action?",
    disable: "Disable",
    debug: "Debug",
    download: "Download",
    dropFiles: "Drop file here | Drop files here",
    edit: "Edit",
    enable: "Enable",
    export: "Export",
    filters: "Filters",
    find: "Find",
    id: "Identifier",
    ignore: "Ignore",
    index: "Index",
    lastModified: "Last save on server",
    lastModifiedOffline: "Last save on browser/device",
    loadOnlineData: "Load online data",
    loadOfflineData: "Load offline data",
    login: "Login",
    max: "Max",
    messages: "Messages",
    min: "Min",
    no: "No",
    noItems: "No items",
    notConnectedOrNotLogged:
      "You are not connected to the network or you are not logged in: some features may not be available.",
    ok: "Ok",
    observers: "Shares",
    offlineData:
      "Data loaded from internal storage. Local data could be different with respect to online data.",
    onlineData: "Data loaded from remote server.",
    permissions: "Permessi",
    remove: "Remove",
    removeBoth: "Remove both from server and from browser/device",
    removeOnline: "Remove from server only",
    removeOffline: "Remove from device only",
    rename: "Rename",
    results: "Results",
    resultsPerPage: "Results per page",
    resultsSubheader: "from {firstIndex} to {lastIndex} out of {totalElements}",
    save: "Save",
    saveBoth: "Save both on server and on browser/device",
    saveOnline: "Save on server only",
    saveOffline: "Save on device only",
    searchMode: "Search mode",
    searchModeOnline: "Server only",
    searchModeOffline: "Device only",
    searchModeBoth: "Server, then device",
    submit: "Submit",
    tags: "Tags",
    upload: "Upload",
    view: "View",
    yes: "Yes"
  },

  // ===========================================================================
  // Status codes
  // ===========================================================================
  errors: {
    "0"  : "Server unreachable.",
    "401": "User not authenticated.",
    "403": "User not authorized.",
    "404": "Not found.",
    "422": "Validation errors.",
    "500": "Error processing your request."
  },

  // ===========================================================================
  // Components
  // ===========================================================================
  fileTable: {
    name: "Name",
    size: "Size",
    progress: "Progress",
    error: "Error",
    removeAll: "Remove all",
    uploadAll: "Upload all",
  },

  graph2: {
    actions: {
      selectAll: 'Select all',
      copy: 'Copy',
      paste: 'Paste',
      delete: 'Delete'
    },

    tools: {
      arcs: 'Arcs',
      ellipse: 'Ellipse',
      nodes: 'Nodes',
      note: 'Note',
      path: 'Path',
      rect: 'Rectangle',
      selection: 'Selection',
      solidArc: 'Solid arc'
    }
  },

  pager: {
    first: "First",
    previous: "Prev.",
    next: "Next",
    last: "Last",
    page: "Page ",
    outOf: " out of {totalPages}."
  },

  storageQuota: {
    message: "You've used {used}, {usedPercentage} % of the available storage.\nYou can write up to {free}."
  },

  // ===========================================================================
  // Pages
  // ===========================================================================
  changePassword: {
    tabs: {
      main: "Change password"
    },
    fields: {
      oldPassword: "Old password",
      newPassword: "New password",
      confirmPassword: "Confirm password"
    }
  },
  login: {
    fields: {
      username: "E-mail",
      password: "Password",
      rememberMe: "Remember me on this browser/device"
    },
    actions: {
      proceed: "Proceed without logging in",
      resetPassword: "Forgot password?"
    }
  },
  resetPassword: {
    fields: {
      email: "E-mail",
    },
    actions: {
      resetPassword: "Reset password",
      goBackToLoginPage: "Go back to login page"
    }
  },
  settings: {
    tabs: {
      main: "Settings"
    },
    fields: {
      username: "Username",
      language: "Language",
      dateFormat: "Date format",
      decimalSeparator: "Decimal separator",
      thousandSeparator: "Thousand separator"
    }
  },

  // ===========================================================================
  // Menu
  // ===========================================================================
  menu: {
    logout: "Logout",
    settings: "Settings",
    changePassword: "Change password",
    info: "Info"
  }
};
